module.exports = __webpack_public_path__ + "static/partner-logo-ffa186f7647ce760333738501b20d452.png";